import { createSelector } from 'reselect';

import { LoadingState } from '../../domain/schemas';
import { SettingsOptionsDataResend } from '../../domain/settingOptionsDataResend';

import { RootState } from '../../store';

// Action Types
const FETCH_SETTINGS_OPTIONS_DATARESEND =
  'FETCH_SETTINGS_OPTIONS_DATARESEND' as const;
const FETCH_SETTINGS_OPTIONS_DATARESEND_REQUEST =
  'FETCH_SETTINGS_OPTIONS_DATARESEND_REQUEST' as const;
const FETCH_SETTINGS_OPTIONS_DATARESEND_SUCCESS =
  'FETCH_SETTINGS_OPTIONS_DATARESEND_SUCCESS' as const;
const RENEW_SETTINGS_OPTIONS_DATARESEND =
  'RENEW_SETTINGS_OPTIONS_DATARESEND' as const;

export const SettingsOptionsDataResendActionTypes = {
  FETCH_SETTINGS_OPTIONS_DATARESEND,
  FETCH_SETTINGS_OPTIONS_DATARESEND_REQUEST,
  FETCH_SETTINGS_OPTIONS_DATARESEND_SUCCESS,
  RENEW_SETTINGS_OPTIONS_DATARESEND,
};

// Action Creators

function fetchSettingsOptionsDataResendAction() {
  return {
    type: FETCH_SETTINGS_OPTIONS_DATARESEND,
  };
}

function fetchSettingsOptionsDataResendRequestAction() {
  return {
    type: FETCH_SETTINGS_OPTIONS_DATARESEND_REQUEST,
  };
}

function fetchSettingsOptionsDataResendSuccessAction(
  settingsOptionsDataResend: SettingsOptionsDataResend
) {
  return {
    type: FETCH_SETTINGS_OPTIONS_DATARESEND_SUCCESS,
    payload: { settingsOptionsDataResend },
  };
}

function renewSettingsOptionsDataResendAction() {
  return {
    type: RENEW_SETTINGS_OPTIONS_DATARESEND,
  };
}

export const SettingsOptionsDataResendActionCreators = {
  fetchSettingsOptionsDataResendAction,
  fetchSettingsOptionsDataResendRequestAction,
  fetchSettingsOptionsDataResendSuccessAction,
  renewSettingsOptionsDataResendAction,
};

// Actions
type SettingsOptionsDataResendAction =
  | ReturnType<typeof fetchSettingsOptionsDataResendAction>
  | ReturnType<typeof fetchSettingsOptionsDataResendRequestAction>
  | ReturnType<typeof fetchSettingsOptionsDataResendSuccessAction>
  | ReturnType<typeof renewSettingsOptionsDataResendAction>;

// State

type SettingsOptionsDataResendState = {
  loadingState: LoadingState;
  settingsOptionsDataResend: SettingsOptionsDataResend;
};

const initialState: SettingsOptionsDataResendState = {
  loadingState: 'prepare',
  settingsOptionsDataResend: {
    searchCondition: {
      halls: [],
    },
  },
};

// Selector

// whole selector
const settingsOptionsDataResendSelector = (state: RootState) =>
  state.settingsOptionsDataResend;

//  ホール一覧を取得
export const settingsOptionsDataResendHallsSelector = createSelector(
  settingsOptionsDataResendSelector,
  ({ settingsOptionsDataResend }) =>
    settingsOptionsDataResend.searchCondition.halls
);

export const settingsOptionsDataResendLoadingStateSelector = createSelector(
  settingsOptionsDataResendSelector,
  ({ loadingState }) => loadingState
);

// Reducer

export function settingsOptionsDataResendReducer(
  state = initialState,
  action: SettingsOptionsDataResendAction
): SettingsOptionsDataResendState {
  switch (action.type) {
    case FETCH_SETTINGS_OPTIONS_DATARESEND_REQUEST:
      return {
        ...state,
        loadingState: 'loading',
      };
    case FETCH_SETTINGS_OPTIONS_DATARESEND_SUCCESS:
      return {
        ...state,
        loadingState: 'loaded',
        settingsOptionsDataResend: action.payload.settingsOptionsDataResend,
      };
    case RENEW_SETTINGS_OPTIONS_DATARESEND:
      return initialState;
    default:
      return state;
  }
}
